import Image from "next/image";

const StepsProcess = () => (
  <div className="flex flex-col xl:flex-row px-4 md:pl-8 MD:pr-0 h-[90vh]">
    <div className="text-center w-full xl:w-1/2">
      <div className="relative bottom-48 md:bottom-[46rem] xl:bottom-[32rem] flex justify-center xl:justify-end fs-0 z-0">
        <Image
          alt={"Lady using NFC Tap-n-connect Social Networking App"}
          className="md:w-3/4"
          src={"/assets/case-study/social-networking/process.webp"}
          width={518}
          height={718}
        />
      </div>
    </div>
    <div className="w-full xl:w-1/2">
      <div className="md:pr-10 -mt-24">
        <div className="relative xl:static bottom-8 md:bottom-[32rem] md:pl-8 xl:pl-16">
          <div className="flex">
            <div>
              <div className="fs-0 border border-dashed border-black w-12 h-12 flex justify-center md:w-16 md:h-16 rounded-7.5 p-3 md:p-4">
                <Image
                  alt={"Understanding requirements"}
                  src={"/assets/case-study/social-networking/understanding.webp"}
                  width={34}
                  height={27}
                />
              </div>
              <div className="h-44 md:h-32 border border-solid border-y-0 border-l-0 border-black/10 mx-auto w-0"></div>
            </div>
            <div className="ml-8">
              <h2 className="text-base md:text-lg font-medium text-black mb-1">
                <span className="font-josefin">Requirement Understanding</span>
              </h2>
              <p className="text-sm font-light text-black/80 text-justify">
                <span className="font-josefin">
                  It was essential to understand the project concept and the
                  client&apos;s long-term vision in detail. We got a detailed
                  idea about the project features and technical challenges and
                  understood the overall project flow, feature set, and the
                  issues the client was facing.
                </span>
              </p>
            </div>
          </div>
          <div className="flex">
            <div>
              <div className="fs-0 border border-dashed border-black w-12 h-12 md:w-16 md:h-16 rounded-7.5 p-3 md:p-4 flex justify-center items-center">
                <Image
                  alt={"Development"}
                  src={"/assets/case-study/social-networking/development.webp"}
                  width={29}
                  height={29}
                />
              </div>
              <div className="h-44 md:h-32 border border-solid border-y-0 border-l-0 border-black/10 mx-auto w-0"></div>
            </div>
            <div className="ml-8">
              <h2 className="text-base md:text-lg font-medium text-black mb-1">
                <span className="font-josefin">Development</span>
              </h2>
              <p className="text-sm font-light text-black/80 text-justify">
                <span className="font-josefin">
                  The biggest challenge was clearing the app code mess upon
                  understanding the project requirement. We created the back end
                  from scratch aligned with PWA, fixed the broken features in
                  the app, and built the core features again to make a stable
                  app live.
                </span>
              </p>
            </div>
          </div>
          <div className="flex">
            <div>
              <div className="fs-0 border border-dashed border-black w-12 h-12 md:w-16 md:h-16 rounded-7.5 p-3 md:p-4 flex justify-center items-center">
                <Image
                  alt={"Quality Assurance"}
                  src={"/assets/case-study/social-networking/quilty.webp"}
                  width={16}
                  height={34}
                />
              </div>
              <div className="h-44 md:h-32 border border-solid border-y-0 border-l-0 border-black/10 mx-auto w-0"></div>
            </div>
            <div className="ml-8">
              <h2 className="text-base md:text-lg font-medium text-black mb-1">
                <span className="font-josefin">Quality Assurance</span>
              </h2>
              <p className="text-sm font-light text-black/80 text-justify">
                <span className="font-josefin">
                  Upon completing the development, including the code quality
                  fixes, the newly built backend, and PWA, the complete mobile
                  app went through serious QA, which included the physical NFC
                  tags and band testing. It ensured the system would not suffer
                  crashes or feature failures.
                </span>
              </p>
            </div>
          </div>
          <div className="flex">
            <div className="fs-0 border border-dashed border-black w-36 h-12 md:h-16 rounded-7.5 p-3 md:p-0 flex justify-center items-center">
              <Image
                alt={"On Time Delivery"}
                src={"/assets/case-study/social-networking/ontime.webp"}
                width={32}
                height={32}
              />
            </div>
            <div className="ml-8">
              <h2 className="text-base md:text-lg font-medium text-black mb-1">
                <span className="font-josefin">On Time Delivery</span>
              </h2>
              <p className="text-sm font-light text-black/80 text-justify">
                <span className="font-josefin">
                  Once we took over the project, it was taken care of with the
                  utmost sincerity. The product was launched on a date we
                  committed to the client. It was rolled out on a large scale
                  and received much positive user feedback. All the late-night
                  work and dedication finally paid off.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default StepsProcess;
